import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<void, 'icon'>()((theme, _, classes) => ({
	breadcrumbWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		marginRight: 'auto',
		marginLeft: 'auto',
		gap: theme.spacing.xxsmall,
	},
	breadcrumb: {
		font: theme.breadCrumb.link.default,
		color: theme.breadCrumb.link.color.default,
		textDecoration: 'underline',
		cursor: 'pointer',

		'&:hover': {
			font: theme.breadCrumb.link.hover,
			textDecoration: 'none',
			color: theme.breadCrumb.link.color.hover,
		},
	},
	nonLinkedBreadcrumb: {
		font: theme.breadCrumb.current.default,
		color: theme.breadCrumb.current.color.default,
	},
	divider: {
		color: theme.breadCrumb.separation.color,
		width: theme.spacing.xxsmall,
		textAlign: 'center',
	},
	homeBreadcrumb: {
		lineHeight: 0,
		cursor: 'pointer',

		[`&:hover > .${classes.icon}`]: {
			color: theme.breadCrumb.link.color.hover,
		},
	},
	icon: {
		width: theme.icon.size.medium,
		color: theme.breadCrumb.link.color.default,
	},
}));
